module.exports = __webpack_public_path__ + "img/vip-3.2beffb29.png";